export default __webpack_public_path__ + "static/media/Bill-Chuan.30f7fedf.png";